import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FloatLabelType } from '@angular/material';
import { TextFormats } from '@mandae/ng-utils/mask';
import { AddressValidatorsService } from '../../services/address-validators.service';
import { AddressAutocompletePickedAddress } from '../components/address-autocomplete/address-autocomplete.component';
import * as _ from 'lodash';

export interface Address {
  postalCode?: string;
  street?: string;
  number?: string;
  district?: string;
  complement?: string;
  city?: string;
  state?: string;
  observation?: string;
}

@Component({
  selector: 'mandae-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss']
})
export class AddressFormComponent implements OnChanges {

  @Input()
  public error: any;

  @Input()
  public address: Address = null;

  @Output()
  public addressChange = new EventEmitter<Address>();

  @Input()
  public floatLabel: FloatLabelType = 'never';

  public form: FormGroup;
  public cepMask = TextFormats.cepMask;

  constructor() {
    this.form = new FormGroup({
      postalCode: new FormControl(null, [Validators.required, Validators.pattern(/^\d{5}-?\d{3}/)]),
      street: new FormControl(null, [Validators.required]),
      number: new FormControl(null, [Validators.required]),
      district: new FormControl(null, [Validators.required]),
      complement: new FormControl(null),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required, AddressValidatorsService.forbiddenState()]),
      observation: new FormControl(null),
    }, {
      updateOn: 'change'
    });

    this.form.valueChanges.subscribe(() => {
      this.address = { ...this.form.value };
      this.addressChange.emit(this.address);
    });
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.address && !_.isEqual(changes.address.currentValue, changes.address.previousValue)) {
      this.setFormAddress(changes.address.currentValue);
    }
  }

  setFormAddress(address: AddressAutocompletePickedAddress) {
    this.address = { ...address, ...{
        complement: this.address && this.address.complement,
        observation: this.address && this.address.observation,
      }
    };

    this.form.patchValue(this.address);
  }

}
